<template>
  <div class="block">
    <div class="block-title header">
      <div class="title">券佣金列表</div>
    </div>
    <commission-list></commission-list>
  </div>
</template>

<script>
import List from './components/list.vue'
import CommissionList from './components/commissionList.vue'
export default {
  components:{
    List,
    CommissionList
  }
}
</script>

<style scoped lang="less">
.header{
  display: flex;
  justify-content: space-between;
  .title{
    font-size: 18px;
    font-weight: 700;
    color: #333;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/douyin/poiDistribution/commission.vue